import type { CSSProperties } from 'react';

export const isContentProtectionEnabled = (allowDownload?: boolean | null) => allowDownload === false;

export const protectedMediaStyle: CSSProperties = {
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    userSelect: 'none',
};

export const preventProtectedAction = (event: any) => {
    if (!event) {
        return;
    }

    if (typeof event.preventDefault === 'function') {
        event.preventDefault();
    }

    if (typeof event.stopPropagation === 'function') {
        event.stopPropagation();
    }
};

export const getProtectedEventHandlers = (enabled: boolean) => {
    if (!enabled) {
        return {};
    }

    return {
        onContextMenu: preventProtectedAction,
        onDragStart: preventProtectedAction,
        onSelectStart: preventProtectedAction,
    };
};